export default __webpack_public_path__ + "static/Logo-OCC-df4bad63fdf4694a3dc3d2028c23d4d6.svg";